import * as documentServicesJsonSchemas from '@wix/document-services-json-schemas'
import _ from 'lodash'

const {
    namespaceMapping: {NAMESPACE_MAPPING}
} = documentServicesJsonSchemas

const savePaths = [
    {path: ['multilingualTranslations']},
    {path: ['DESKTOP']},
    {path: ['MOBILE']},
    {path: ['orphanPermanentDataNodes']},
    {path: ['routers']},

    {path: ['pagesPlatformApplications', 'pagesPlatformApplications']},
    {path: ['semanticAppVersions', 'semanticAppVersions']},

    {path: ['rendererModel'], id: 'siteMetaData'},
    {path: ['rendererModel'], id: 'pageToHashedPassword'},
    {path: ['rendererModel'], id: 'siteInfo'},
    {path: ['rendererModel'], id: 'metaSiteId'},
    {path: ['rendererModel'], id: 'premiumFeatures'},
    {path: ['rendererModel'], id: 'clientSpecMap'},
    {path: ['rendererModel'], id: 'wixCodeModel'},
    {path: ['rendererModel'], id: 'routers'},

    {path: ['documentServicesModel'], id: 'siteName'},
    {path: ['documentServicesModel'], id: 'editorSessionId'},
    {path: ['documentServicesModel'], id: 'customHeadTags'},
    {path: ['documentServicesModel'], id: 'metaSiteData'}
].concat(Object.keys(NAMESPACE_MAPPING).map(namespace => ({path: [namespace]})))

const shouldSaveDiff = (diff, additionalPaths = []) => {
    for (const {path, id} of _.concat(savePaths, additionalPaths)) {
        const value = _.get(diff, path)
        if (typeof value === 'object' && value !== null) {
            if (id) {
                if (value.hasOwnProperty(id)) {
                    return true
                }
            } else if (!_.isEmpty(value)) {
                return true
            }
        }
    }
    return false
}

const revisionPointer = {type: 'documentServicesModel', id: 'versionInfo', innerPath: ['revision']}
const versionPointer = {type: 'documentServicesModel', id: 'versionInfo', innerPath: ['version']}

const versionPath = ['documentServicesModel', 'versionInfo', 'version']
const revisionPath = ['documentServicesModel', 'versionInfo', 'revision']

const lastTransactionIdPath = ['documentServicesModel', 'autoSaveInfo', 'lastTransactionId']

export {versionPath, revisionPath, revisionPointer, versionPointer, lastTransactionIdPath, shouldSaveDiff}
